<template>
    <div class="loading-spinner" />
</template>

<script>
export default {
    name: 'LoadingSpinner',
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.loading-spinner {
    border: 2px solid transparent;
    border-bottom-color: $primary;
    border-left-color: $primary;
}
</style>
